import React, { useEffect, useState } from "react";
import { Select } from "@material-tailwind/react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import useDataStore from "../../stores/useDataStore";
import { X } from "lucide-react";

// const validationSchema = Yup.object({
//   title: Yup.object({
//     en: Yup.string().required("English title is required"),
//     ar: Yup.string().required("Arabic title is required"),
//   }),
//   description: Yup.object({
//     en: Yup.string().required("English description is required"),
//     ar: Yup.string().required("Arabic description is required"),
//   }),
//   duration: Yup.object({
//     en: Yup.string().required("English duration is required"),
//     ar: Yup.string().required("Arabic duration is required"),
//   }),
//   introVideo: Yup.string().url("Must be a valid URL").nullable(),
//   // Add more validation if needed
// });

const CreateCourseModal = ({ onClose, courseToEdit }) => {
    const { createCourse, updateCourse, getAllTrainers, allTrainers } = useDataStore();

     useEffect(() => {
        getAllTrainers();
    }, []);


    const formik = useFormik({
        initialValues: {
            moodleId: courseToEdit?.moodleId || "",
            title: courseToEdit?.title || { en: "", ar: "" },
            description: courseToEdit?.description || { en: "", ar: "" },
            duration: courseToEdit?.duration || { en: "", ar: "" },
            introVideo: courseToEdit?.introVideo || "",
            benefits: courseToEdit?.benefits || [{ en: "", ar: "" }],
            program_structure: courseToEdit?.program_structure || [
                {
                    module: { en: "", ar: "" },
                    topics: [{ en: "", ar: "" }],
                },
            ],
            trainer: courseToEdit?.trainer || "",
        },
        enableReinitialize: true, // مهم عشان يعيد تعيين القيم لو تغير courseToEdit

        onSubmit: async (values, { resetForm }) => {
            let response;
            if (courseToEdit?._id) {
                console.log(courseToEdit?._id);

                // تحديث الكورس
                response = await updateCourse(courseToEdit._id, values);
                if (response) toast.success("Course updated successfully!");
                else toast.error("Failed to update course.");
            } else {
                // إنشاء كورس جديد
                response = await createCourse(values);
                if (response) {
                    toast.success("Course created successfully!");
                    resetForm();
                } else toast.error("Failed to create course.");
            }
            if (response) onClose();
        },
    });

    const handleInputChange = (e, section, lang, modIndex = null, itemIndex = null, key = null) => {
        const value = e.target.value;

        if (section === "benefits") {
            const newBenefits = [...formik.values.benefits];
            if (modIndex !== null) {
                newBenefits[modIndex][lang] = value;
                formik.setFieldValue("benefits", newBenefits);
            }
        }
        else if (section === "program_structure") {
            const updatedModules = [...formik.values.program_structure];
            if (modIndex !== null) {
                if (itemIndex === null) {
                    // Module name
                    updatedModules[modIndex].module[lang] = value;
                } else {
                    // Topic inside the module
                    updatedModules[modIndex].topics[itemIndex][lang] = value;
                }
                formik.setFieldValue("program_structure", updatedModules);
            }
        }
        else if (section === "modules") {
            // modules is part of program_structure, so handle similarly
            const newModules = [...formik.values.program_structure];
            if (modIndex !== null) {
                newModules[modIndex].module[lang] = value;
                formik.setFieldValue("program_structure", newModules);
            }
        }
        else if (section === "topics") {
            const newModules = [...formik.values.program_structure];
            if (modIndex !== null && itemIndex !== null) {
                newModules[modIndex].topics[itemIndex][lang] = value;
                formik.setFieldValue("program_structure", newModules);
            }
        }


        else {
            // fallback for other simple sections
            formik.setFieldValue(`${section}.${lang}`, value);
        }
    };


    const addBenefit = () => {
        const newBenefits = [...formik.values.benefits, { en: "", ar: "" }];
        formik.setFieldValue("benefits", newBenefits);
    };

    const removeBenefit = (index) => {
        const newBenefits = formik.values.benefits.filter((_, i) => i !== index);
        formik.setFieldValue("benefits", newBenefits.length ? newBenefits : [{ en: "", ar: "" }]);
    };



    // Add a new module
    const addModule = () => {
        const newModules = [
            ...formik.values.program_structure,
            { module: { en: "", ar: "" }, topics: [{ en: "", ar: "" }] },
        ];
        formik.setFieldValue("program_structure", newModules);
    };

    // Remove a module
    const removeModule = (index) => {
        const updated = formik.values.program_structure.filter((_, i) => i !== index);
        formik.setFieldValue(
            "program_structure",
            updated.length ? updated : [{ module: { en: "", ar: "" }, topics: [{ en: "", ar: "" }] }]
        );
    };

    // Add a topic to a specific module
    const addTopic = (moduleIndex) => {
        const newModules = [...formik.values.program_structure];
        newModules[moduleIndex].topics.push({ en: "", ar: "" });
        formik.setFieldValue("program_structure", newModules);
    };

    // Remove a topic from a specific module
    const removeTopic = (moduleIndex, topicIndex) => {
        const newModules = [...formik.values.program_structure];
        newModules[moduleIndex].topics = newModules[moduleIndex].topics.filter((_, i) => i !== topicIndex);
        if (newModules[moduleIndex].topics.length === 0) {
            newModules[moduleIndex].topics = [{ en: "", ar: "" }];
        }
        formik.setFieldValue("program_structure", newModules);
    };



    return (
        <section className=" p-4 fixed inset-0 z-50 flex items-center justify-center bg-black/80">
            <div className="flex justify-between items-center border-b pb-2">
                <button onClick={onClose} className="absolute top-10 right-10 text-white hover:text-gray-400">
                    <X className="h-8 w-8 " />
                </button>
            </div>

            <form onSubmit={formik.handleSubmit} className="max-h-[80vh] w-11/12 mx-auto overflow-y-auto p-4   bg-white rounded-md">
                <h1 className="text-3xl font-bold mb-8  text-center">
                    {courseToEdit ? "Edit Course" : "Create New Course"}
                </h1>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-4">

                    {/* Course Name */}
                    <div>
                        <label className="block text-sm font-medium ">Course Name EN</label>
                        <input name="title.en" type="text" placeholder="Strength and Endurance Training" value={formik.values.title.en} onChange={(e) => handleInputChange(e, "title", "en")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full  " />
                        {formik.errors.title?.en && <p className="text-red-500">{formik.errors.title.en}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium ">Course Name AR</label>
                        <input name="title.ar" type="text" placeholder="تدريب القوة والتحمل" value={formik.values.title.ar} onChange={(e) => handleInputChange(e, "title", "ar")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.title?.ar && <p className="text-red-500">{formik.errors.title.ar}</p>}
                    </div>

                    {/* Description */}
                    <div>
                        <label className="block text-sm font-medium ">Description EN</label>
                        <input name="description.en" type="text" placeholder="A comprehensive fitness course..." value={formik.values.description.en} onChange={(e) => handleInputChange(e, "description", "en")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.description?.en && <p className="text-red-500">{formik.errors.description.en}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium ">Description AR</label>
                        <input name="description.ar" type="text" placeholder="دورة لياقة بدنية..." value={formik.values.description.ar} onChange={(e) => handleInputChange(e, "description", "ar")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.description?.ar && <p className="text-red-500">{formik.errors.description.ar}</p>}
                    </div>

                    {/* Duration */}
                    <div>
                        <label className="block text-sm font-medium ">Duration EN</label>
                        <input name="duration.en" type="text" placeholder="8 weeks" value={formik.values.duration.en} onChange={(e) => handleInputChange(e, "duration", "en")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.duration?.en && <p className="text-red-500">{formik.errors.duration.en}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium ">Duration AR</label>
                        <input name="duration.ar" type="text" placeholder="8 أسابيع" value={formik.values.duration.ar} onChange={(e) => handleInputChange(e, "duration", "ar")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.duration?.ar && <p className="text-red-500">{formik.errors.duration.ar}</p>}
                    </div>


                    {/* Moodle ID */}
                    <div className="mb-4">
                        <label htmlFor="moodleId" className="block text-sm font-medium text-gray-700">
                            Moodle ID
                        </label>
                        <input
                            type="text"
                            id="moodleId"
                            name="moodleId"
                            value={formik.values.moodleId}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full  "
                            placeholder="Enter Moodle ID"
                        />
                        {formik.touched.moodleId && formik.errors.moodleId ? (
                            <p className="mt-1 text-xs text-red-600">{formik.errors.moodleId}</p>
                        ) : null}
                    </div>

                    {/* trainers */}

                    <div className="">
                        <label className="block text-sm font-medium mb-2">Trainer</label>

                        <Select
                            value={formik.values.trainer}  // use formik's value directly
                            onValueChange={(val) => formik.setFieldValue("trainer", val)}  // update formik state
                            className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full "   // Keep container full width or adjust as needed
                            placeholder="Select Trainer"
                        >
                            <Select.Trigger placeholder="Select Trainer" className="p-2 rounded-md border border-gray-300 shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                            <Select.List>
  {Array.isArray(allTrainers) && allTrainers.length > 0 ? (
    allTrainers.map((trainer) => (
      <Select.Option
        key={trainer._id}
        value={trainer._id}
        className="p-2 hover:bg-blue-100"
      >
        {trainer.name.en}
      </Select.Option>
    ))
  ) : (
    [
      <Select.Option key="loading" value="" disabled>
        Loading trainers...
      </Select.Option>
    ]
  )}
</Select.List>

                        </Select>

                    </div>


                    {/* Intro Video */}
                    <div className="md:col-span-2">
                        <label className="block text-sm font-medium ">Intro Video (YouTube URL)</label>
                        <input name="introVideo" type="text" placeholder="https://www.youtube.com/watch?v=abc000000" value={formik.values.introVideo} onChange={(e) => formik.setFieldValue("introVideo", e.target.value)} className="input w-full p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                        {formik.errors.introVideo && <p className="text-red-500">{formik.errors.introVideo}</p>}
                    </div>


                    <div className="md:col-span-2 border shadow-md p-4 rounded">
                        <label className="block font-semibold mb-2">Benefits</label>

                        {formik.values?.benefits?.map((benefit, index) => (
                            <div
                                key={index}
                                className="border p-4 rounded mb-4 flex items-center justify-between gap-4"
                            >
                                <div className="flex-1">
                                    <label className="block text-sm font-medium">Benefit EN</label>
                                    <input
                                        name={`benefits[${index}].en`}
                                        type="text"
                                        placeholder="Benefit EN"
                                        value={benefit.en}
                                        onChange={(e) => handleInputChange(e, "benefits", "en", index)}
                                        className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                    />
                                </div>

                                <div className="flex-1">
                                    <label className="block text-sm font-medium">Benefit AR</label>
                                    <input
                                        name={`benefits[${index}].ar`}
                                        type="text"
                                        placeholder="Benefit AR"
                                        value={benefit.ar}
                                        onChange={(e) => handleInputChange(e, "benefits", "ar", index)}
                                        className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                    />
                                </div>

                                <div className="flex flex-col justify-center">
                                    {formik.values.benefits.length > 1 && (
                                        <button
                                            type="button"
                                            onClick={() => removeBenefit(index)}
                                            className="text-red-500 hover:text-red-700 border border-red-500 hover:border-red-700 text-xs font-semibold px-2 py-2 mt-4 rounded self-start"
                                            title="Remove benefit"
                                        >
                                            - Remove
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}

                        {/* زر الإضافة مستقل تحت القائمة */}
                        <div className="mt-2">
                            <button
                                type="button"
                                onClick={addBenefit}
                                className="text-green-500 hover:text-green-700 border border-green-500 hover:border-green-700 text-xs font-semibold px-2 py-2 rounded"
                                title="Add benefit"
                            >
                                + Add Benefits
                            </button>
                        </div>


                    </div>


                    {/* Program Structure - Module */}
                    {/* <div>
                        <label className="block text-sm font-medium ">Module EN</label>
                        <input name="program_structure[0].module.en" type="text" placeholder="Endurance Building" value={formik.values.program_structure[0].module.en} onChange={(e) => handleInputChange(e, "program_structure", "en", 0, "module")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                    </div>
                    <div>
                        <label className="block text-sm font-medium ">Module AR</label>
                        <input name="program_structure[0].module.ar" type="text" placeholder="بناء التحمل" value={formik.values.program_structure[0].module.ar} onChange={(e) => handleInputChange(e, "program_structure", "ar", 0, "module")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                    </div> */}


                    {/* Program Structure - Topic */}
                    {/* <div>
                        <label className="block text-sm font-medium ">Topic EN</label>
                        <input name="program_structure[0].topics[0].en" type="text" placeholder="Topic EN" value={formik.values.program_structure[0].topics[0].en} onChange={(e) => handleInputChange(e, "program_structure", "en", 0, "topics")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                    </div>
                    <div>
                        <label className="block text-sm font-medium ">Topic AR</label>
                        <input name="program_structure[0].topics[0].ar" type="text" placeholder="Topic AR" value={formik.values.program_structure[0].topics[0].ar} onChange={(e) => handleInputChange(e, "program_structure", "ar", 0, "topics")} className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full " />
                    </div> */}





                    <div className="md:col-span-2 border shadow-md p-4 rounded">
                        <label className="block font-semibold mb-2">Program Structure (Modules & Topics)</label>

                        {formik?.values?.program_structure?.map((mod, modIndex) => (
                            <div key={modIndex} className="border   p-4 rounded mb-4">
                                {/* Module Title Inputs */}
                                <div className="flex gap-4 mb-3">
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium">Module EN</label>
                                        <input
                                            value={mod.module.en}
                                            onChange={(e) => handleInputChange(e, "program_structure", "en", modIndex)}
                                            className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                            placeholder="Module EN"
                                        />
                                    </div>
                                    <div className="flex-1">
                                        <label className="block text-sm font-medium">Module AR</label>
                                        <input
                                            value={mod.module.ar}
                                            onChange={(e) => handleInputChange(e, "program_structure", "ar", modIndex)}
                                            className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                            placeholder="Module AR"
                                        />
                                    </div>

                                    <div className="flex flex-col justify-center gap-2">
                                        {formik.values.program_structure.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removeModule(modIndex)}
                                                className="text-red-500 hover:text-red-700 border border-red-500 hover:border-red-700 text-xs font-semibold px-2 py-2 mt-4 rounded self-start"
                                                title="Remove module"
                                            >
                                                - Remove
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {/* Topics for this module */}
                                {mod?.topics?.map((topic, topicIndex) => (
                                    <div key={topicIndex} className="flex gap-4 items-center mb-2">
                                        <div className="flex-1">
                                            <label className="block text-sm font-medium">Topic EN</label>
                                            <input
                                                value={topic.en}
                                                onChange={(e) => handleInputChange(e, "program_structure", "en", modIndex, topicIndex)}
                                                className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                                placeholder="Topic EN"
                                            />
                                        </div>
                                        <div className="flex-1">
                                            <label className="block text-sm font-medium">Topic AR</label>
                                            <input
                                                value={topic.ar}
                                                onChange={(e) => handleInputChange(e, "program_structure", "ar", modIndex, topicIndex)}
                                                className="input p-2 my-1 border shadow-md rounded-md focus:outline-none focus:shadow-lg w-full"
                                                placeholder="Topic AR"
                                            />
                                        </div>
                                        <div className="flex flex-col justify-center gap-2">
                                            {mod.topics.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => removeTopic(modIndex, topicIndex)}
                                                    className="text-red-500 hover:text-red-700 border border-red-500 hover:border-red-700 text-xs font-semibold px-2 py-2 mt-4 rounded self-start"
                                                    title="Remove topic"
                                                >
                                                    - Remove
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                ))}

                                {/* Add Topic Button */}
                                <div>
                                    <button
                                        type="button"
                                        onClick={() => addTopic(modIndex)}
                                        className="text-green-500 hover:text-green-700 border border-green-500 hover:border-green-700 text-xs font-semibold px-2 py-2 rounded"
                                        title="Add topic"
                                    >
                                        + Add Topic
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* Add Module Button */}
                        <div className="mb-4">
                            <button
                                type="button"
                                onClick={addModule}
                                className="text-green-500 hover:text-green-700 border border-green-500 hover:border-green-700 text-xs font-semibold px-2 py-2 rounded"
                                title="Add module"
                            >
                                + Add Module
                            </button>
                        </div>
                    </div>


















                    {/* Trainer Name */}

                </div>

                <div className="m-8 border-t pt-4 flex justify-end gap-2">
                    <button type="button" onClick={onClose} className="bg-red-700 hover:bg-red-600 text-white px-6 py-2 rounded shadow">Cancel</button>
                    <button type="submit" className="bg-black text-white hover:scale-105 transition-all duration-150  px-6 py-2 rounded shadow" disabled={formik.isSubmitting}>
                        {/* {formik.isSubmitting ? "Adding Course...." : "Add Course"} */}
                        {formik.isSubmitting ? (courseToEdit ? "Editing Course..." : "Creating New Course..."):  (courseToEdit ? "Edit Course" : "Create New Course")}
                    </button>
                </div>
            </form>

        </section>
    );
};

export default CreateCourseModal;
